import UserEvent from "../../core/internal/event/UserEvent"
import { UserEventEmitter } from "../../core/internal/event/UserEventEmitter"
import { InAppMessageTriggerProcessor } from "./trigger/InAppMessageTriggerProcessor"
import { InAppMessageResetProcessor } from "./reset/InAppMessageResetProcessor"
import { UserListener } from "../../core/internal/user/UserListener"
import { User } from "../../core/internal/model/model"
import { PropertyOperations } from "../property/PropertyOperations"
import { InAppMessageScheduleProcessor } from "./schedule/InAppMessageScheduleProcessor"
import { InAppMessageDelayStorage } from "./storage/InAppMessageDelayStorage"
import { InAppMessageSchedule } from "./schedule/InAppMessageSchedule"
import { Clock } from "../../core/internal/util/TimeUtil"

export default class InAppMessageManager implements UserListener {
  constructor(
    private readonly scheduleProcessor: InAppMessageScheduleProcessor,
    private readonly delayStorage: InAppMessageDelayStorage,
    private readonly triggerProcessor: InAppMessageTriggerProcessor,
    private readonly resetProcessor: InAppMessageResetProcessor,
    private readonly userEventEmitter: UserEventEmitter,
    private readonly clock: Clock
  ) {
    this.initialize()
  }

  private initialize() {
    /**
     * add event listener
     */
    this.userEventEmitter.on("event", (event) => {
      this.onEvent(event)
    })
  }

  destroy() {
    this.userEventEmitter.off("event", (event) => {
      this.onEvent(event)
    })
  }

  onEvent(event: UserEvent) {
    this.triggerProcessor.process(event)
  }

  /**
   * @override
   */
  onUserUpdated(oldUser: User, newUser: User, timestamp: number): void {
    this.resetProcessor.process(oldUser, newUser)
  }

  /**
   * @override
   */
  onPropertyOperations(_user: User, _operations: PropertyOperations, _timestamp: number): void {
    // noop
  }

  loadDelaySchedule() {
    /**
     * schedule delay from DelayStorage
     * if the delay is expired, remove the delay from DelayStorage
     */
    this.delayStorage.values().forEach((delay) => {
      const delayRestoredAt = this.clock.currentMillis()

      const scheduleRequest = InAppMessageSchedule.fromDelayStorageEntity(delay, delayRestoredAt).toRequest(
        "STORED",
        delayRestoredAt
      )
      void this.scheduleProcessor.process(scheduleRequest)
    })
  }
}
